<template>
    <div class="profile-menu-desktop">
        <el-row type="flex" justify="left">

            <el-col :xs="{span: 24}" :sm="{span: 24}" style="max-width: 220px; border-right-color: #dcdfe6; border-right-style:solid; border-right-width: 1px;" class="hidden-sm-and-down">
                <el-divider>{{user.username || 'Anonymous'}}</el-divider>
                <el-row type="flex" justify="center">
                    <el-image :src="userAvatar" @click="changeMode('profile')" style="cursor: pointer;"></el-image>
                    <el-image :src="user.currentStatus === 'online' ? onlineIcon : offlineIcon" class="user-profile-status"></el-image>

                    <div class="peaking-tag" v-if="layout === 'peaking'">Peaking</div>
                </el-row>

                <span v-if="layout === 'peaking'">
                    <!---------------------------->
                    <!-- Show declined if declined -->
                    <!---------------------------->
                    <el-row type="flex" justify="left" v-if="user.status === 'decline'">
                        <el-col :xs="{span: 24}" :sm="{span: 24}">
                            <el-row type="flex" justify="left">
                                <p class="retro" style="width:100%; margin-bottom: 5px; text-align: center;">Friend-request declined</p>
                            </el-row>
                            <el-row type="flex" justify="left">
                                <p class="retro friend-status-declined" style="font-size:12px; width:100%; text-align: center;">Status: declined</p>
                            </el-row>
                        </el-col>
                    </el-row>

                    <!---------------------------->
                    <!-- Send friendship -->
                    <!---------------------------->
                    <el-row type="flex" justify="left" v-if="user.status === 'none'">
                        <el-col :xs="{span: 24}" :sm="{span: 24}">
                            <el-row type="flex" justify="left">
                                <p class="retro" style="width:100%; margin-bottom: 5px; text-align: center;">No friends yet</p>
                            </el-row>
                            <el-row type="flex" justify="left">
                                <el-button  size="small" type="success" plain class="retro" style="width: 100%; margin: 5px;" icon="el-icon-plus" @click="sendFriendRequest" :loading="submitting">Send friend request</el-button>
                            </el-row>
                        </el-col>
                    </el-row>

                    <!---------------------------->
                    <!-- End friendship -->
                    <!---------------------------->
                    <el-row type="flex" justify="left" v-if="user.status === 'accepted'">
                        <el-col :xs="{span: 24}" :sm="{span: 24}">
                            <el-row type="flex" justify="left">
                                <p class="retro" style="width:100%; margin-bottom: 5px; text-align: center;">Friends</p>
                            </el-row>
                            <el-row type="flex" justify="left">
                                <el-button size="small" type="danger" plain class="retro" style="width: 100%; margin: 5px;" icon="el-icon-close" @click="submitFriendRequest('decline')" :loading="submitting">End friendship</el-button>
                            </el-row>
                        </el-col>
                    </el-row>

                    <!---------------------------->
                    <!-- Show cancel button if waiting for response -->
                    <!---------------------------->
                    <el-row type="flex" justify="left" v-if="user.status === 'waiting'">
                        <el-col :xs="{span: 24}" :sm="{span: 24}">
                            <el-row type="flex" justify="left">
                                <p class="retro" style="width:100%; margin-bottom: 5px; text-align: center;">Outgoing friend-request</p>
                            </el-row>
                            <el-row type="flex" justify="left">
                                <el-button size="small" type="danger" plain class="retro" style="width: 100%; margin: 5px;" icon="el-icon-close" @click="submitFriendRequest('decline')" :loading="submitting">Cancel request</el-button>
                            </el-row>
                        </el-col>
                    </el-row>

                    <!---------------------------->
                    <!-- Show accept or decline buttons if receiving request -->
                    <!---------------------------->
                    <el-row type="flex" justify="left" v-if="user.status === 'pending'">
                        <el-col :xs="{span: 24}" :sm="{span: 24}">
                            <el-row type="flex" justify="left" v-if="user">
                                <p class="retro" style="width:100%; margin-bottom: 5px; text-align: center;">Received friend-request:</p>
                            </el-row>

                            <el-row type="flex" justify="left" v-if="user">
                                <el-button size="small" type="success" plain class="retro" style="width: 50%; margin: 5px;" icon="el-icon-check" @click="submitFriendRequest('accept')" :loading="submitting">Accept</el-button>
                                <el-button size="small" type="danger" plain class="retro" style="width: 50%; margin: 5px;" icon="el-icon-close" @click="submitFriendRequest('decline')" :loading="submitting">Decline</el-button>
                            </el-row>
                        </el-col>
                    </el-row>
                </span>

                <span v-if="layout === 'default'">
                    <el-row type="flex" justify="left">
                        <el-button size="small" type="primary" plain :class="`retro ${mode === 'profile' ? 'active' : ''}`" style="width: 100%; margin: 5px;" @click="changeMode('profile')">Profile</el-button>
                    </el-row>
                    <el-row type="flex" justify="left" >
                        <el-button size="small" type="primary" plain :class="`retro ${mode === 'settings' ? 'active' : ''}`" style="width: 100%; margin: 5px;" @click="changeMode('settings')">Settings</el-button>
                    </el-row>
                    <el-row type="flex" justify="left">
                        <el-badge :value="user.counts.receivedRequests" class="notifier-badge" v-if="user.counts.receivedRequests">
                            <el-button size="small" type="primary" plain :class="`retro ${mode === 'friends' ? 'active' : ''}`" style="width: 100%; margin: 5px;" @click="changeMode('friends')">Friends {{user.counts.friends ? `: (${user.counts.friends})`: ''}}</el-button>
                        </el-badge>
                        <el-button v-else size="small" type="primary" plain :class="`retro ${mode === 'friends' ? 'active' : ''}`" style="width: 100%; margin: 5px;" @click="changeMode('friends')">Friends {{user.counts.friends ? ` (${user.counts.friends})`: ''}}</el-button>
                    </el-row>
                    <el-row type="flex" justify="left">
                        <el-button size="small" type="primary" plain :class="`retro ${mode === 'addFriend' ? 'active' : ''}`" style="width: 100%; margin: 5px;" @click="changeMode('addFriend')">Add friend</el-button>
                    </el-row>
                </span>

                <el-divider v-if="user.counts">Games</el-divider>
                <el-row type="flex" justify="left" v-if="user.counts">
                    <el-button size="small" type="primary" plain :class="`retro ${mode === 'myGames' ? 'active' : ''}`" style="width: 100%; margin: 5px;" @click="changeMode('myGames')">All my games{{user.counts.myGames ? ` (${user.counts.myGames})`: ''}}</el-button>
                </el-row>

                <el-row type="flex" justify="left" v-if="user.counts">
                    <el-button size="small" type="primary" plain :class="`retro ${mode === 'going2play' ? 'active' : ''}`" style="width: 100%; margin: 5px;" @click="changeMode('going2play')">Going to play {{user.counts.going2playGames ? ` (${user.counts.going2playGames})`: ''}}</el-button>
                </el-row>

                <el-row type="flex" justify="left" v-if="user.counts">
                    <el-button size="small" type="primary" plain :class="`retro ${mode === 'playing' ? 'active' : ''}`" style="width: 100%; margin: 5px;" @click="changeMode('playing')">Playing {{user.counts.playingGames ? ` (${user.counts.playingGames})`: ''}}</el-button>
                </el-row>
                <el-row type="flex" justify="left" v-if="user.counts">
                    <el-button size="small" type="primary" plain :class="`retro ${mode === 'finished' ? 'active' : ''}`" style="width: 100%; margin: 5px;" @click="changeMode('finished')">Finished {{user.counts.finishedGames ? ` (${user.counts.finishedGames})`: ''}}</el-button>
                </el-row>
                <el-row type="flex" justify="left" v-if="user.counts">
                    <el-button size="small" type="primary" plain :class="`retro ${mode === 'played' ? 'active' : ''}`" style="width: 100%; margin: 5px;" @click="changeMode('played')">Played {{user.counts.playedGames ? ` (${user.counts.playedGames})`: ''}}</el-button>
                </el-row>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import Background from '@/components/background.vue'

export default {
  name: 'ProfileMenuMobile',
  components: { Background },
  props: {
    changeMode: {
      default: () => {}
    },
    sendFriendRequest: {
      default: () => {}
    },
    submitFriendRequest: {
      default: () => {}
    },
    user: {
      default: {}
    },
    mode: {
      default: 'profile'
    },
    layout: {
      default: 'default'
    },
    submitting: {
      default: false
    }
  },
  mounted () {},
  data () {
    return {
      userAvatar: require(`@/assets/${this.user.avatar || 'avatar1'}.png`),
      onlineIcon: require(`@/assets/icon-onn.png`),
      offlineIcon: require(`@/assets/icon-off.png`),
      awayIcon: require(`@/assets/icon-away.png`)
    }
  },

  methods: {}
}
</script>

<style lang="scss">
@import '../styles/variables.scss';

.profile-menu-desktop {
    .user-profile-status {
        position: absolute;
        margin-left: 87px;
        margin-top: 262px;
    }

    .el-dropdown {
        color: $main-color-2;
        font-size: $font-size-regular;
    }

    .peaking-tag {
        font-size: 18px;
        color: #4e5953;
        position: absolute;
        background-color:$main-color-2;
        bottom: 0px;
        padding-right: 5px;
        padding-left: 5px;
        padding-top: 5px;
        padding-bottom: 5px;
        border-width: 4px;
        border-style: solid;
        border-color: #4e5953;
    }
}
</style>
